/**
 * ScheduleGenerationModal
 * Modal pour programmer la génération des articles
 */
import React from 'react';
import { Clock } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../../../components/ui/card';
import { Button } from '../../../components/ui/button';
import { Input } from '../../../components/ui/input';

export const ScheduleGenerationModal = ({
  schedGenModal,
  scheduling,
  onClose,
  onDateChange,
  onConfirm,
}) => {
  if (!schedGenModal) return null;

  return (
    <div 
      className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-center justify-center z-50 p-4" 
      onClick={onClose} 
      data-testid="sched-gen-modal"
    >
      <Card className="border-cyan-500/50 bg-slate-900 max-w-md w-full" onClick={e => e.stopPropagation()}>
        <CardHeader>
          <CardTitle className="text-sm text-cyan-300 flex items-center gap-2">
            <Clock className="w-4 h-4" /> Programmer la génération
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-3">
          <div className="text-xs text-slate-400">
            Le scraping des sources sera tenté avant la programmation. Si toutes les URLs
            sont OK, la génération sera déclenchée automatiquement à l&apos;heure prévue.
          </div>
          <div>
            <label className="text-[10px] text-slate-500 uppercase">Date et heure (heure locale)</label>
            <Input
              type="datetime-local"
              value={schedGenModal.date}
              onChange={e => onDateChange(e.target.value)}
              className="w-full"
              data-testid="sched-gen-datetime-input"
            />
            <div className="text-[10px] text-slate-500 mt-1">
              Par défaut : prochaine occurrence de 01h00 (l&apos;outil travaille la nuit). Modifiable.
            </div>
          </div>
          <div className="flex justify-end gap-2 pt-2">
            <Button onClick={onClose} variant="outline" size="sm" data-testid="sched-gen-cancel-btn">
              Annuler
            </Button>
            <Button
              onClick={onConfirm}
              disabled={scheduling}
              className="bg-cyan-600 hover:bg-cyan-500"
              size="sm"
              data-testid="sched-gen-confirm-btn"
            >
              <Clock className="w-3 h-3 mr-1" /> {scheduling ? 'Vérification…' : 'Programmer'}
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default ScheduleGenerationModal;
